import { render, staticRenderFns } from "./digipoPortal.vue?vue&type=template&id=0cd0b3b1&scoped=true&"
import script from "./digipoPortal.vue?vue&type=script&lang=js&"
export * from "./digipoPortal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cd0b3b1",
  null
  
)

export default component.exports